import { Injectable } from '@angular/core';
import { EnvironmentVariables } from '@shared/interfaces/environment-variables';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentVariableService {
  private environmentVariablesCore: EnvironmentVariables = {};

  get environmentVariables(): EnvironmentVariables {
    return this.environmentVariablesCore;
  }

  init(): void {
    this.environmentVariablesCore = this.readEnvironmentVariablesFromDocument();
  }

  private readEnvironmentVariablesFromDocument(): EnvironmentVariables {
    try {
      const injectedElement = document.querySelector<HTMLElement>(
        'script[type="application/json"][data-inline-id="msp-sd-env"]',
      );

      if (injectedElement) {
        return JSON.parse(injectedElement.textContent);
      }
    } catch {}

    return {};
  }
}
